var map = {
	"./Bear612a_4c.svg": "./src/assets/logos/4-Color/Bear612a_4c.svg",
	"./Bear612b_4c.svg": "./src/assets/logos/4-Color/Bear612b_4c.svg",
	"./Bear978_4c.svg": "./src/assets/logos/4-Color/Bear978_4c.svg",
	"./Bulldog448_4c.svg": "./src/assets/logos/4-Color/Bulldog448_4c.svg",
	"./Bulldog713_4c.svg": "./src/assets/logos/4-Color/Bulldog713_4c.svg",
	"./Bulldog924_4c.svg": "./src/assets/logos/4-Color/Bulldog924_4c.svg",
	"./Cavalier075_4c.svg": "./src/assets/logos/4-Color/Cavalier075_4c.svg",
	"./Cougar356_4c.svg": "./src/assets/logos/4-Color/Cougar356_4c.svg",
	"./Cougar460_4c.svg": "./src/assets/logos/4-Color/Cougar460_4c.svg",
	"./Cougar_4c.svg": "./src/assets/logos/4-Color/Cougar_4c.svg",
	"./Cowboy Bandit800_4c.svg": "./src/assets/logos/4-Color/Cowboy Bandit800_4c.svg",
	"./Cowboy619_4c.svg": "./src/assets/logos/4-Color/Cowboy619_4c.svg",
	"./Dragon363_4c.svg": "./src/assets/logos/4-Color/Dragon363_4c.svg",
	"./Eagle Face004_4c.svg": "./src/assets/logos/4-Color/Eagle Face004_4c.svg",
	"./Eagle238_4c.svg": "./src/assets/logos/4-Color/Eagle238_4c.svg",
	"./Eagle319_4c2.svg": "./src/assets/logos/4-Color/Eagle319_4c2.svg",
	"./Eagle473_4c.svg": "./src/assets/logos/4-Color/Eagle473_4c.svg",
	"./Falcon329_4c.svg": "./src/assets/logos/4-Color/Falcon329_4c.svg",
	"./Falcon901_4c.svg": "./src/assets/logos/4-Color/Falcon901_4c.svg",
	"./Griffin451_4c.svg": "./src/assets/logos/4-Color/Griffin451_4c.svg",
	"./Hawk238_4c.svg": "./src/assets/logos/4-Color/Hawk238_4c.svg",
	"./Hawk319_4c.svg": "./src/assets/logos/4-Color/Hawk319_4c.svg",
	"./Husky909_4c.svg": "./src/assets/logos/4-Color/Husky909_4c.svg",
	"./Knigh390_4c.svg": "./src/assets/logos/4-Color/Knigh390_4c.svg",
	"./Knigh390_5c.svg": "./src/assets/logos/4-Color/Knigh390_5c.svg",
	"./Knight-horse012_4c.svg": "./src/assets/logos/4-Color/Knight-horse012_4c.svg",
	"./Knight-sword175_4c.svg": "./src/assets/logos/4-Color/Knight-sword175_4c.svg",
	"./Knight175_4c.svg": "./src/assets/logos/4-Color/Knight175_4c.svg",
	"./Knight175_5c.svg": "./src/assets/logos/4-Color/Knight175_5c.svg",
	"./Knight246_4c.svg": "./src/assets/logos/4-Color/Knight246_4c.svg",
	"./Knight439_4c.svg": "./src/assets/logos/4-Color/Knight439_4c.svg",
	"./Knights Shield_4c.svg": "./src/assets/logos/4-Color/Knights Shield_4c.svg",
	"./Leopard869_4c.svg": "./src/assets/logos/4-Color/Leopard869_4c.svg",
	"./Lion Face981_4c.svg": "./src/assets/logos/4-Color/Lion Face981_4c.svg",
	"./Lion853_4c2.svg": "./src/assets/logos/4-Color/Lion853_4c2.svg",
	"./Mustang341_4c.svg": "./src/assets/logos/4-Color/Mustang341_4c.svg",
	"./Panther356_4c.svg": "./src/assets/logos/4-Color/Panther356_4c.svg",
	"./Panther460_4c.svg": "./src/assets/logos/4-Color/Panther460_4c.svg",
	"./Panther859_4c.svg": "./src/assets/logos/4-Color/Panther859_4c.svg",
	"./Panther871_4c.svg": "./src/assets/logos/4-Color/Panther871_4c.svg",
	"./Pirate600_4c.svg": "./src/assets/logos/4-Color/Pirate600_4c.svg",
	"./Pirate600_5c.svg": "./src/assets/logos/4-Color/Pirate600_5c.svg",
	"./Pirate992_4c.svg": "./src/assets/logos/4-Color/Pirate992_4c.svg",
	"./Pirate992_5c.svg": "./src/assets/logos/4-Color/Pirate992_5c.svg",
	"./Pirate992_7c.svg": "./src/assets/logos/4-Color/Pirate992_7c.svg",
	"./Ram894_4c.svg": "./src/assets/logos/4-Color/Ram894_4c.svg",
	"./Raven545_4c.svg": "./src/assets/logos/4-Color/Raven545_4c.svg",
	"./Razorback511_4c.svg": "./src/assets/logos/4-Color/Razorback511_4c.svg",
	"./Spartan051_4c.svg": "./src/assets/logos/4-Color/Spartan051_4c.svg",
	"./Tiger599_4c.svg": "./src/assets/logos/4-Color/Tiger599_4c.svg",
	"./Trojan955_4c.svg": "./src/assets/logos/4-Color/Trojan955_4c.svg",
	"./Viking295_4c.svg": "./src/assets/logos/4-Color/Viking295_4c.svg",
	"./Viking295_5c.svg": "./src/assets/logos/4-Color/Viking295_5c.svg",
	"./Viking607_4c.svg": "./src/assets/logos/4-Color/Viking607_4c.svg",
	"./Wildcat Territory_4c.svg": "./src/assets/logos/4-Color/Wildcat Territory_4c.svg",
	"./Wolf912_4c.svg": "./src/assets/logos/4-Color/Wolf912_4c.svg",
	"./Wolves927_4c2.svg": "./src/assets/logos/4-Color/Wolves927_4c2.svg",
	"./bear300_4c.svg": "./src/assets/logos/4-Color/bear300_4c.svg",
	"./mustang588_4c.svg": "./src/assets/logos/4-Color/mustang588_4c.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/logos/4-Color sync recursive ^\\.\\/.*$";